module.exports = __webpack_public_path__ + "static/media/cp401.22eab230.png";